
<script>
    import WelcomeComponent from '../../../../components/onboarding/welcomebanner';
    import {axios} from '../../../../bootstrap';

    export default {
        name: "SMSOnBoarding",
        components: {WelcomeComponent},
        methods: {
            activateBulkSMS() {
                axios.post(`web/projects/${this.project.id}/products/on-boarding`, {
                    product: 'bulk-sms'
                }).then(() => {
                    this.$router.push(`/projects/${this.project.id}/overview`)
                });
            }
        }
    }
</script>
<template>
    <div class="row">
        <welcome-component product="Bulk SMS and short codes"/>
        <div class="narrow-width-page">
            <div class="row">
                <div class="col-md-3 col-lg-4">
                    <div class="st-product-card">
                        <div class="st-product-card-header">
                            <span class="icon-circle webchat">
                                <i class="si si-envelope"/>
                            </span>
                        </div>
                        <div class="st-product-card-body">
                            <h6>Keep in touch with your customers with scheduled personalized messaging</h6>
                        </div>
                        <div class="st-product-card-body-x">
                            <p>Market and communicate with your customers with the most effective messaging service.</p>
                        </div>

                        <div class="st-product-card-actions">
                            <el-button type="primary" size="small" @click="activateBulkSMS">
                                Activate
                                <i class="ml-1 el-icon-right"/>
                            </el-button>
                            <el-button plain size="small" class="ml-2">More ..</el-button>
                        </div>
                    </div>
                </div>

                <div class="col-md-3 col-lg-4">
                    <div class="st-product-card">
                        <div class="st-product-card-header">
                    <span class="icon-circle mobile">
                        <i class="el-icon-s-comment"/>
                    </span>

                        </div>

                        <div class="st-product-card-body">
                            <h6>Engage with your customer from your <b>mobile</b> app.</h6>
                        </div>

                        <div class="st-product-card-body-x">
                            <p>Get the emalify chat sdk and embed in your mobile app so your app users can interact with you from the app.</p>
                        </div>

                        <div class="st-product-card-actions">
                            <el-tag type="primary">Coming soon ...</el-tag>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped lang="scss">
    .narrow-width-page {
        padding: 1%;
    }
    @import "src/sass/custom/onboarding";
</style>
